export const SET_WAITING = 'SET_WAITING'
export const SET_FINISHED = 'SET_FINISHED'
export const SET_PROVIDERS_DATA = 'SET_PROVIDERS_DATA'
export const SET_CURRENT_PROVIDERS = 'SET_CURRENT_PROVIDERS'
export const SET_SHOW_UNLOCKED_LEVELS = 'SET_SHOW_UNLOCKED_LEVELS'
export const SET_SHOW_UNLOCKED_BADGES = 'SET_SHOW_UNLOCKED_BADGES'
